import type { ModerationEntity, ModifierGroup } from '../model/schema';
import { modifierGroupSchema, modifierOptionSchema } from '../model/schema';
import { entityBag, entityNumber } from './entity-bag';

/** Whole minutes behind `cook_time_seconds`. */
export function cookTimeMinutes(entity: ModerationEntity): number | undefined {
  const seconds = entityNumber(entity, 'cook_time_seconds');
  if (seconds === undefined) return undefined;
  return Math.round(seconds / 60);
}

/**
 * Modifier groups on the product entity. Both levels parse per-item: one
 * malformed option (or group) is skipped without voiding its siblings.
 */
export function entityModifiers(entity: ModerationEntity): ModifierGroup[] {
  const value: unknown = entityBag(entity).modifiers;
  if (!Array.isArray(value)) return [];
  return value.flatMap((item): ModifierGroup[] => {
    if (item === null || typeof item !== 'object' || Array.isArray(item)) return [];
    const bag = item as Record<string, unknown>;
    const parsed = modifierGroupSchema.safeParse({ ...bag, options: [] });
    if (!parsed.success) return [];
    const options = Array.isArray(bag.options)
      ? bag.options.flatMap((option) => {
          const parsedOption = modifierOptionSchema.safeParse(option);
          return parsedOption.success ? [parsedOption.data] : [];
        })
      : [];
    return [{ ...parsed.data, options }];
  });
}
